module.exports = __webpack_public_path__ + "static/media/Mcarousel2bg.2b8ba4c8.png";